export default window

declare let window: {
  [key: string]: any
  GA?: string
}
